import { GreetingKey } from "@/apps/merchant3/types/ChatBotGreetingKeys";

declare global {
  interface Window {
    adaSettings: {
      metaFields: Record<string, string | null>;
    };
    adaEmbed;
  }
}

export const openChatAfterSeconds = (
  seconds: number,
  greetingKey: string = GreetingKey.DEFAULT
): void => {
  const chatbotAda = typeof window.adaEmbed !== "undefined";
  if (chatbotAda) {
    const interval: number = setInterval(async () => {
      const { isChatOpen } = window.adaEmbed.getInfo();
      if (isChatOpen) {
        window.adaEmbed.toggle();
      }
      window.adaEmbed.reset({
        greeting: greetingKey,
        metaFields: window.adaSettings.metaFields,
      });
      window.adaEmbed.toggle();
      clearInterval(interval);
    }, seconds * 1000);
  }
};
